import {
    BlotterComponentState,
    initialBlotterComponentState,
} from './BlotterComponentsState';
import {
    BlotterComponentsAction,
    BlotterComponentsActionType,
} from './actions';

export default function blotterComponentReducer(
    state: BlotterComponentState = initialBlotterComponentState,
    action: BlotterComponentsAction
): BlotterComponentState {
    switch (action.type) {
        case BlotterComponentsActionType.BLOTTER_COMPONENT_SET_SELECTED_ROW_IDS: {
            return {
                ...state,
                selectedRowIds: action.payload!.selectedRowIds,
            };
        }
    }
    return state;
}
